import { AUTH_TYPES } from "../types";

const initialState = {
  access_token: "",
  userName: "",
  role: "",
  party_id: "",
  language_code: "",
};



export const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_TYPES.LOGIN: 
    return {
        ...state,
        access_token: payload.access_token,
        userName: payload.userName,
        role: payload.role,
        party_id: payload.party_id,
        language_code: payload.language_code,
      };
    
    case AUTH_TYPES.REGISTER:
      return state;
    default:
      return state;
  }
};
